package com.essntl.features.invoice.ui.addeditinvoice.components.content

import androidx.compose.foundation.layout.*
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.essntl.core.quickbooks.data.QuickbookSparseRequest
import core.dateformat.utils.formatDateToYYYYMMDD
import core.dateformat.utils.fromDDTOMM
import com.essntl.features.invoice.ui.addeditinvoice.AddEditInvoiceEvent
import com.essntl.features.invoice.ui.addeditinvoice.AddEditInvoiceState
import com.essntl.features.invoice.ui.addeditinvoice.AddEditInvoiceValidation
import com.essntl.uikit.components.button.primary.EsMediumPrimaryButton
import com.essntl.uikit.components.input.date.EsDateInput
import com.essntl.uikit.components.input.label.EsInputLabel
import com.essntl.uikit.components.toggle.EsTab
import com.essntl.uikit.components.toggle.TabState
import com.essntl.uikit.components.utils.EsModifiers.LargeSectionModifier
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography
import core.dateformat.ui.formatDate

@Composable
fun AddEditInvoiceDetails(
    state: AddEditInvoiceState,
    validation: AddEditInvoiceValidation,
    onEvent: (AddEditInvoiceEvent) -> Unit,
) {
    val tabItems = listOf(
        TabState(index = 0, text = "Travel agent"),
        TabState(index = 1, text = "Traveller"),
    )

    val (selectedTabIndex, setSelectedTabIndex) = remember {
        mutableStateOf(tabItems.first().index)
    }

    val qb = state.getQuickbooksInvoice.data

    Row(
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(3.spacing),
        modifier = LargeSectionModifier,
    ) {
        if (qb == null)
            Column {
                EsInputLabel(
                    label = "Bill to",
                    modifier = Modifier,
                )

                Spacer(modifier = Modifier.height(.5f.spacing))

                EsTab(
                    items = tabItems,
                    selectedItemIndex = selectedTabIndex,
                    tabWidth = 120.dp,
                    onClick = { tabState ->
                        onEvent(
                            AddEditInvoiceEvent.ToggleClientTravelAgent(
                                value = tabState.index == 1,
                            ),
                        )
                        setSelectedTabIndex(tabState.index)
                    },
                )

                Spacer(modifier = Modifier.height(1.spacing))

                Text(
                    text = if (state.clientInvoice)
                        state.getProposal.data?.primaryClient?.prettyName
                            ?: state.getItinerary.data?.proposal?.primaryClient?.prettyName ?: "No client found!" else
                        state.getProposal.data?.travelAgent?.prettyName
                            ?: state.getItinerary.data?.proposal?.travelAgent?.prettyName ?: "No travel agent found!",
                    style = MaterialTheme.esTypography.p1Regular16,
                    color = MaterialTheme.esColorScheme.textPrimary,
                )
            }

        EsDateInput(
            value = state.dueDate,
            onValueChange = {
                validation.addEditInvoiceForm.dueDate.validate(it)
                onEvent(AddEditInvoiceEvent.UpdateDueDateField(it))
            },
            label = "Due date",
            message = "This field is required",
            state = validation.addEditInvoiceForm.dueDate.state,
            modifier = Modifier.then(
                if (qb == null)
                    Modifier.weight(1f) else
                    Modifier.fillMaxWidth(0.3f),
            ),
        )

        qb?.let {
            Spacer(modifier = Modifier.width(1.spacing))

            EsMediumPrimaryButton(
                onClick = {
                    onEvent(
                        AddEditInvoiceEvent.SparseUpdateInvoice(
                            quickbookSparseRequest = QuickbookSparseRequest(
                                Id = it.Id,
                                DueDate = formatDateToYYYYMMDD(fromDDTOMM(state.dueDate)),
                                SyncToken = it.SyncToken,
                                sparse = true,
                            ),
                        ),
                    )
                },
                text = "Update",
                enabled = validation.addEditInvoiceForm.isValid &&
                    state.dueDate != it.DueDate.formatDate(),
                loading = state.sparseUpdateInvoice.isLoading,
            )
        }
    }
}